import React from 'react';
import { RefinementList } from 'react-instantsearch';
import sortBy from 'lodash.sortby';

import FilterBlock from '../../elements/FilterBlock';
import PastItemFilter from '../../elements/PastItemFilter';
import EventFilterDateRange from '../EventFilterDateRange';
import { useScreenMinLg } from '@hooks/useResponsive';

const sortItems = items => sortBy(items, ['label']);

const EventFilters = () => {
    const isScreenMinLg = useScreenMinLg();

    return (
        <>
            <FilterBlock label="Date" defaultExpanded={isScreenMinLg}>
                <PastItemFilter />
                <EventFilterDateRange />
            </FilterBlock>

            <FilterBlock label="State/Province">
                <RefinementList attribute="state_province" limit={99999} transformItems={sortItems} />
            </FilterBlock>

            <FilterBlock label="Country">
                <RefinementList attribute="location.country" limit={99999} transformItems={sortItems} />
            </FilterBlock>

            <FilterBlock label="Global Region">
                <RefinementList attribute="location.region" limit={99999} transformItems={sortItems} />
            </FilterBlock>

            <FilterBlock label="Meeting Type">
                <RefinementList attribute="event_types" limit={99999} transformItems={sortItems} />
            </FilterBlock>
        </>
    );
};

export default EventFilters;
